var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.35337 11.8527C6.15846 12.0484 5.84188 12.0489 5.64627 11.854L0.161785 6.38902C-0.0539287 6.17408 -0.0539278 5.82477 0.161785 5.60982L5.64627 0.14484C5.84188 -0.0500734 6.15846 -0.0495088 6.35337 0.1461C6.54829 0.34171 6.54772 0.658292 6.35212 0.853206L1.18753 5.99942L6.35211 11.1456C6.54772 11.3406 6.54829 11.6571 6.35337 11.8527ZM10.3524 11.8527C10.1575 12.0484 9.8409 12.0489 9.64529 11.854L4.16081 6.38902C3.94509 6.17408 3.9451 5.82477 4.16081 5.60982L9.64529 0.14484C9.8409 -0.0500734 10.1575 -0.0495088 10.3524 0.1461C10.5473 0.34171 10.5467 0.658292 10.3511 0.853206L5.18656 5.99942L10.3511 11.1456C10.5467 11.3406 10.5473 11.6571 10.3524 11.8527Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.c922ecfb1b78b4562760a0c313c5d7e9.svg";
export { ForwardRef as ReactComponent };